import React from 'react';

import '../Widget.scss';

interface Link {
  name: string;
  link: string;
}

const LINKS: Link[] = [
  {
    name: 'Produksjonskost',
    link: 'https://docs.google.com/spreadsheets/d/1bthCGhwPNc8qOzz6GDIsNUCyFOGOsjmVOk88RF1Wiz0/edit?usp=sharing',
  },

  {
    name: 'HMS Sjekkliste for vernerunde',
    link: 'https://drive.google.com/file/d/1HVdQMGiNyRoV13lNfCq37sESbrfFJS1C/view?usp=sharing',
  },

  {
    name: 'Dispatch oppgaver',
    link: 'https://docs.google.com/presentation/d/1Qe8sPCi7gZXDhw51kqSL16MkPHLs7cH9sh1P2GrhDWo/edit?usp=sharing',
  },

  {
    name: '',
    link: '',
  },
  {
    name: 'Sjåfør Fakturaunderlag',
    link: 'https://docs.google.com/spreadsheets/d/1cWBImF7K6N1NlKRNsIPRq8ovH9b_f44-FJEYDeWbi-Q/edit?usp=sharing',
  },
  {
    name: '',
    link: '',
  },
  {
    name: 'Underlag:',
    link: '',
  },
  {
    name: '',
    link: '',
  },
  {
    name: 'Xfrakt',
    link: 'https://docs.google.com/spreadsheets/d/1VKiQjzUSUQJc4_mXEDYWKAU4N-Xfm-t90fDhhWaPcmc/edit?usp=sharing',
  },
  {
    name: 'Jacob Service',
    link: 'https://docs.google.com/spreadsheets/d/1oVfPLciyj145x_23WjvwyBXdZy3h1cUt3mHK3-Ezt8Y/edit?usp=sharing',
  },
  {
    name: 'GF Transport',
    link: 'https://docs.google.com/spreadsheets/d/19lOefxkU4hLAaOPe_7W_I9q2f2W189RjEglPR3GetzY/edit#gid=0',
  },
  {
    name: 'Oslo Budservice',
    link: 'https://docs.google.com/spreadsheets/d/1TBU0HAbXldaSHCft4H0ycJKe-Zeu5ruO5DR3cbzi-4Y/edit?pli=1#gid=0',
  },
  {
    name: 'Stovner Transport',
    link: 'https://docs.google.com/spreadsheets/d/141Ejq7rtCud9zq_fxMtiAHGSNs_b1h9Iqyf2hN5rDZ8/edit?usp=sharing',
  },

  {
    name: '',
    link: '',
  },
  {
    name: 'Couriers',
    link: '',
  },
  {
    name: 'Drivers Schedule',
    link: 'https://dispatch.porterbuddy.com/shift',
  },
  {
    name: 'Courier garage',
    link: 'https://docs.google.com/spreadsheets/d/1-Xj5kOAbXjLC-3T5PNBOKJdtF2nTN9fkB30hXkuwulY/edit?usp=sharing',
  },
  {
    name: 'Courier screening',
    link: 'https://docs.google.com/spreadsheets/d/1Z4L_iHmS91Zc1VHS8qXXy_CIJidYH1p4jpHs-kEyEq4/edit?usp=sharing',
  },

  {
    name: '',
    link: '',
  },
];

export default function LinksWidget() {
  return (
    <div className="widget">
      <div className="widget__header">
        <h5>Useful links</h5>
      </div>
      <div style={{ height: 10 }} />
      {LINKS.map((link, index) => {
        return (
          <div key={index} className="widget__text">
            {link.name ? (
              <>
                {link.link && (
                  <a href={link.link} target="_blank" rel="noopener noreferrer">
                    {link.name}
                  </a>
                )}
                {!link.link && <h6>{link.name}</h6>}
              </>
            ) : (
              <div style={{ height: 10 }} />
            )}
          </div>
        );
      })}
      <div style={{ height: 10 }} />
    </div>
  );
}
